import { use_slice_workspace } from '@/hooks/store/use_slices';
import { WorkspaceAvatarEdit } from '../_base/WorkspaceAvatarEdit';
import InputWorkspaceName from './InputWorkspaceName';

function ViewWorkspaceInfo() {
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  return (
    <div className="flex items-center gap-2">
      <WorkspaceAvatarEdit className="!size-12" workspace={workspace_current} />
      <div className="flex flex-col">
        <InputWorkspaceName />
      </div>
    </div>
  );
}

export default ViewWorkspaceInfo;
